import React, { useRef, useState } from 'react';
import './howitworks.css'
import Carousel from 'react-bootstrap/Carousel';
import img from '../../assets/images/OCHA3-1-2-1.png'
import img2 from '../../assets/images/Japan-Times2.png'
import img3 from '../../assets/images//Screenshot_222.png'


const HowItWorks = () => {
  return (
    <div>
    <div id="projects" className="section">
      <div className="logo-container w-container">
        <h2 className="gm---heading-2">HOW IT WORKS</h2>
        
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-sm-6 col-12">
                    <div className="how-it-works-img-block">
                        <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57aaf_image%2023.png" alt="How it works Gammadda" className="image-16"/>
                    </div>
                    <div className="how-it-works-text-block">
                        <h5 className="heading-5">PROJECT PRIORITIZATION &amp; SELECTION</h5>
                        <p>We undertake a nationwide needs assessment called the Door-to-Door survey, knocking on thousands
                            of doors to identify and understand the problems rural communities face.</p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-6 col-12">
                    <div className="how-it-works-img-block">
                        <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57aad_image%2022.png" alt="How it works Gammadda" className="image-16"/>
                    </div>
                    <div className="how-it-works-text-block">
                        <h5 className="heading-5">Fundraising</h5>
                        <p>We collect donations for the projects from various donors through our web portal 
                            you too can be a part of transforming Sri Lanka through citizen action.</p>
                    </div>
                </div>
                <div className="col">
                    <div className="how-it-works-img-block">
                        <img src="https://cdn.newsfirst.lk/gammadda/66abaebec6aed14e82f57ab0_image%2024.png" alt="How it works Gammadda" className="image-16"/>
                    </div>
                    <div className="how-it-works-text-block">
                        <h5 className="heading-5">Project Sustainability</h5>
                        <p>A Gammadda Saviya Society work to ensure long term community success by assisting in the formation of a community- led committee. 
                            This committee is formed in locations where Gammadda projects are implemented.</p>
                    </div>
                </div>
            </div>
        </div>

        

        
      </div>
    </div>
    </div>
  )
}

export default HowItWorks